import { ApiResponse, Job } from 'auth0'
import { nextApiRoutesClient } from 'modules/common/http/nextApiRoutesClient'
import { getAuthorizationHeader } from 'modules/common/lib/api/getAuthorizationHeader'

export interface PostVerificationEmailProps {
  accessToken: string
}
export const postVerificationEmail = async ({
  accessToken,
}: PostVerificationEmailProps) => {
  const { data } = await nextApiRoutesClient.post<ApiResponse<Job>>(
    '/api/auth/sendVerificationEmail',
    {},
    { headers: getAuthorizationHeader(accessToken) }
  )

  return data
}
